import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../helpers/reducerRegistry'
import { handlePieChartData } from '../helper'
import { getBusinessSize } from './thunk'

const initialState = {
  value: [],
  loading: true,
}

const slice = createSlice({
  name: 'portfolioInsights/segment/businessDistribution',
  initialState,
  reducers: {
    resetBusinessDistribution: (state) => {
      state.value = []
      state.loading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBusinessSize.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getBusinessSize.fulfilled, (state, { payload }) => {
      state.value = handlePieChartData(payload)
      state.loading = false
    })
    builder.addCase(getBusinessSize.rejected, (state, action) => {
      state.loading = action.payload.loading
    })
  },
})

export const { resetBusinessDistribution } = slice.actions

export const selectSegmentScoreBusinessSize = (callback) => (state) => {
  const data = state[slice.name].value
  return callback ? callback(data) : data
}
export const selectLoading = (state) => state[slice.name].loading

register(slice.name, slice.reducer)
